import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=5ed54908&scoped=true&"
import script from "./FileBrowser.vue?vue&type=script&lang=js&"
export * from "./FileBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=5ed54908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed54908",
  null
  
)

export default component.exports